import type { BrandId } from '@sluitstraat/core';

export const INFORMAL_BRANDS: readonly string[] = ['nu91', 'default'];

export const isInformalBrand = (brand: BrandId | string): boolean => INFORMAL_BRANDS.includes(brand);
